import { render, staticRenderFns } from "./TestDriveRetailerSelectionComponent.vue?vue&type=template&id=8a654bb0"
import script from "./TestDriveRetailerSelectionComponent.vue?vue&type=script&lang=ts"
export * from "./TestDriveRetailerSelectionComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports